module.exports = __webpack_public_path__ + "img/base_photo.4def3d73.svg";